import { render } from "./LeaveConflict.vue?vue&type=template&id=2343da8e"
import script from "./LeaveConflict.vue?vue&type=script&lang=js"
export * from "./LeaveConflict.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__